module.exports = __webpack_public_path__ + "img/blogs.5912ad6e.jpg";